import { Address } from '../types/business';

const orEmpty = (str: string) => str || '';

const generateGoogleBusinessScript = (business) => {
  const address: Address = business && business.primaryAddress;
  // address is a mandatory field
  return (
    address && {
      '@context': 'https://schema.org',
      '@type': 'HomeAndConstructionBusiness',
      name: business.name,
      address: {
        '@type': 'PostalAddress',
        streetAddress: `${address.address1} ${orEmpty(
          address.address2
        )} ${orEmpty(address.address3)} ${orEmpty(address.address4)}`.trim(),
        addressLocality: address.city,
        addressRegion: address.province,
        postalCode: address.postalCode1,
        addressCountry: address.countryCode,
        '@hasMap': {
          '@type': 'Map',
          mapType: 'https://schema.org/TransitMap',
        },
      },
      url: business.website,
      telephone: business.phone,
      image: [business.logoUrl],
    }
  );
};

const generateGoogleBusinessesScript = (businesses) => {
  if (!businesses) {
    return [];
  }
  return businesses
    .map((b) => generateGoogleBusinessScript(b))
    .filter((o) => !!o);
};

export { generateGoogleBusinessesScript, generateGoogleBusinessScript };
